/**
 * Registers CSS custom properties used by animations throughout the app.
 * Must be called once at app startup (from `app.js`).
 *
 * `--glow-angle` — used by the AI search bar rotating conic-gradient glow.
 * Requires `@property` / `CSS.registerProperty` so CSS interpolates the value
 * as an `<angle>`; without it the custom property is treated as a string and
 * can't animate smoothly.
 */
export function registerCssProperties(): void {
  if (typeof CSS === 'undefined' || !CSS.registerProperty) {
    return;
  }

  try {
    CSS.registerProperty({
      name: '--glow-angle',
      syntax: '<angle>',
      initialValue: '0deg',
      inherits: false,
    });
  } catch {
    /* already registered (happens on HMR reloads) */
  }
}
